import type { Icon as TablerIconType, IconProps } from "@tabler/icons-react";
import { cx } from "../tv";

export type TablerIcon = TablerIconType;
/** Sizes by name (DESIGN-RULES 7): chip 14, row 16 (rows, buttons, chips), side 18 (sidebar), rail 20. */
export type IconSize = "chip" | "row" | "side" | "rail";
const PX: Record<IconSize, number> = { chip: 14, row: 16, side: 18, rail: 20 };

type Props = Omit<IconProps, "size" | "stroke"> & { icon: TablerIcon; size?: IconSize; label?: string };

/** The only way to draw an icon. The stroke follows --icon-stroke (CSS beats the SVG attribute), so it matches the type.
 *  Decorative unless a label is given. */
export function Icon({ icon: Glyph, size = "row", label, className, style, ...rest }: Props) {
  return (
    <Glyph
      size={PX[size]}
      stroke={1.6}
      className={cx("shrink-0", className)}
      style={{ strokeWidth: "var(--icon-stroke)", ...style }}
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? "img" : undefined}
      {...rest}
    />
  );
}
